import { EnumLiteralsOf } from '../../types'

export const Product = {
  Flight: 1,
  Hotel: 5,
  Car: 8
} as const

export type ProductType = EnumLiteralsOf<typeof Product>

export interface CrossSellContentBlock {
  product: 'hotel' | 'flight' | 'car'
  xSellMessaging: string
  xSellTarget: 'Rental Cars' | 'Hotels' | 'Flights'
  date: string
  headline: string
  subHeadline: string
  xSellUrl: string
}

interface CommonBookingProperties {
  offerId: string
  secureToken: string
  productId: ProductType
  travelStartDateTime: string
  travelEndDateTime: string
  originLocationCode: string
  destinationLocationCode: string
  destinationCity: string
  destinationCountryCode: string
  utcCheckInDateTime: string
}

type Pricing = {
  currencySymbol: string
  disclaimer: string
  price: string
  priceDescription: string
}

type Partner = {
  name?: string
  url?: string
}

type VehicleFeatures = {
  bagCapacity: number
  isAirConditioned: boolean
  isUnlimitedMileage: boolean
  mileageDistance: string
  mileageUnit: string
  peopleCapacity: number
}

type Rate = {
  currencyCode: string
  currencySymbol: string
  dailyPrice: string
  isFreeCancellation: boolean
  isPrepay: boolean
  savingsPriceTotal: string
  strikeThroughPrice: string
  totalPrice: string
}

type Inventory<T> = {
  listings: T[]
}

export type HotelInventory = Inventory<HotelListing>

export type CarInventory = Inventory<CarListing>

export type CarListing = {
  bannerType: string
  carExample: string
  carImageUrl: string
  href: string
  id: string
  isCarExampleExact: boolean
  options: string[]
  partner: Partner
  pricing: Pricing
  rate: Rate
  checkoutUrl: string
  vehicleFeatures: VehicleFeatures
}

export type HotelListing = {
  currency: string
  currencySymbol: string
  currentPrice: number
  guestRating: number
  guestReviewCount: number
  hotelId: string
  href: string
  imageUrl: string
  location: string
  name: string
  originalPrice: number
  savingPercentage: number | null
  starRating: number
}

export type CarInventoryParams = {
  returnLocation: string
  pickupLocation: string
  returnDateTime: string
  pickupDateTime: string
  tokenType: string
  offerToken: string
}

export type HotelItineraryDetails = {
  cityId: number
  cityName: string
  checkIn: number
  checkOut: number
}

export type HotelInventoryParams = HotelItineraryDetails & {
  appc: string
  cguid: string
  dealTypes: boolean
  rid: string
  productId: number
  pageSize: number
}

export type HotelBooking = { productId: typeof Product.Hotel } & Omit<
  CommonBookingProperties,
  'originLocationCode'
>
export type FlightBooking = { productId: typeof Product.Flight } & Omit<
  CommonBookingProperties,
  'utcCheckInDateTime' | 'destinationCountryCode'
>
export type CarBooking = { productId: typeof Product.Car } & Omit<
  CommonBookingProperties,
  'originLocationCode' | 'destinationLocationCode' | 'destinationCountryCode'
>
export type Booking = HotelBooking | FlightBooking | CarBooking
export type Listing = CarListing | HotelListing
